import { observable } from 'mobx';
import { AccountUserRoles } from './AccountUser';
import { Integration } from './Integration';

export interface AccountProps {
  accountId: string,
  slug: string | null,
  stripeAccountId: string,
  mode?: string,
  created: string,
  name: string,
  logo: string,
  address: string,
  accentColor: string,
  updated: string,
  currency: string,
  currencies?: string[],
  integrations?: Integration[],
  role: AccountUserRoles
}

export class Account {
  accountId: string = '';
  stripeAccountId: string = '';
  // 'Live' | 'Test'. Fixed at creation; the API rejects changes.
  mode: string = 'Live';
  created: string = '';
  currency: string = '';
  currencies: string[] = [];
  role: AccountUserRoles = AccountUserRoles.NONE;

  @observable name: string = '';
  @observable slug: string | null = '';
  @observable logo: string = '';
  @observable address: string = '';
  @observable accentColor: string = '';
  @observable updated: string = '';
  @observable integrations: Integration[] = [];

  constructor(data: AccountProps) {
    Object.assign(this, data);
  }
}